<template>
  <div class="order-payments">
    <div class="order-payments_top-wrapper">
      <div class="order-payments_title">Оплата</div>
      <a
        href="/help/payment/"
        target="_blank"
        class="order-payments_link-about">
        Подробнее про оплату заказа
      </a>
    </div>
    <PaymentInner v-if="getIsInnerPaymentShow"/>
    <div class="order-payments_items">
      <el-row
        type="flex"
        :gutter="20"
        class="order-payments_row">
        <template v-for="item in getPayments">
          <el-col
            :sm="8"
            :xs="24"
            :key="item.id">
            <PaymentsItem :item="item"/>
          </el-col>
        </template>
      </el-row>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import PaymentsItem from './PaymentsItem'
  import PaymentInner from './PaymentInner'

  export default {
    name: 'Payments',
    components: {
      PaymentsItem,
      PaymentInner
    },
    computed: {
      ...mapGetters('order', [
        'getPayments',
        'getIsInnerPaymentShow'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/Payments.vue